import React from "react";
import { Route } from "react-router-dom";
import { BenefisCategoryCard } from "./BenefisCategoryCard";
import { BenefisCategoryEditDialog } from "./benefis-category-edit-dialog/BenefisCategoryEditDialog";
import { BenefisCategoryUIProvider } from "./BenefisCategoryUIContext";
import { PrivateRoute } from "../../../PrivateRoute";
import { RoleChecker } from "../../../RoleChecker";
import { BenefisCategoryDeleteDialog } from "./benefis-category-delete-dialog/BenefisCategoryDeleteDialog";

export function BenefisCategoryPage({ history }) {
  const benefisCategoryUIEvents = {
    newBenefisCategoryButtonClick: () => {
      history.push("/master-data/category/benefisCategory/new");
    },
    openEditBenefisCategoryPage: (id) => {
      history.push(`/master-data/category/benefisCategory/${id}/edit`);
    },
    openDeleteBenefisCategoryPage: (id) => {
      history.push(`/master-data/category/benefisCategory/${id}/delete`);
    },
  };

  return (
    <BenefisCategoryUIProvider
      benefisCategoryUIEvents={benefisCategoryUIEvents}
    >
      <PrivateRoute
        role={RoleChecker("Create", "benefis_category")}
        component={BenefisCategoryEditDialog}
        path="/master-data/category/benefisCategory/new"
      />
      <PrivateRoute
        role={RoleChecker("Edit", "benefis_category")}
        component={BenefisCategoryEditDialog}
        path="/master-data/category/benefisCategory/:id/edit"
      />
      <PrivateRoute
        role={RoleChecker("Delete", "benefis_category")}
        component={BenefisCategoryEditDialog}
        path="/master-data/category/benefisCategory/:id/edit"
      />

      <Route path="/master-data/category/benefisCategory/new">
        {({ history, match }) => (
          <BenefisCategoryEditDialog
            show={match != null}
            onHide={() => {
              history.push("/master-data/category/benefisCategory");
            }}
          />
        )}
      </Route>
      <Route path="/master-data/category/benefisCategory/:id/edit">
        {({ history, match }) => (
          <BenefisCategoryEditDialog
            show={match != null}
            id={match && match.params.id}
            onHide={() => {
              history.push("/master-data/category/benefisCategory");
            }}
          />
        )}
      </Route>
      <Route path="/master-data/category/benefisCategory/:id/delete">
        {({ history, match }) => (
          <BenefisCategoryDeleteDialog
            show={match != null}
            id={match && match.params.id}
            onHide={() => {
              history.push("/master-data/category/benefisCategory");
            }}
          />
        )}
      </Route>

      <BenefisCategoryCard />
    </BenefisCategoryUIProvider>
  );
}
